import React from 'react';
import styled from 'styled-components';
import { COLORS } from '../../Variables';
import { useTranslation } from 'react-i18next';

const GdprCheckboxContainer = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  span {
    position: relative;
    top: 8px;
    color: ${COLORS.fontColor};
    font-size: 12px;
    text-align: left;
    line-height: 1.5;
    a {
      color: ${COLORS.fontColor};
      text-decoration: none;
    }
  }
`;

const GdprCheckbox = ({ inputName, type, onChange }) => {
  const {t} = useTranslation();

  return (
    <GdprCheckboxContainer htmlFor={inputName} >
      <input type={type} name={inputName} onChange={onChange} id={inputName} />
      <span>{t('petition_form.gdpr_checkbox_label')}</span>
    </GdprCheckboxContainer>
  );
};

export default GdprCheckbox;
